import {
  BookOpen,
  ClipboardCheck,
  ChevronDown,
  Database,
  LogOut,
  NotebookTabs,
  ShieldCheck,
} from "lucide-react";
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Link,
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { mathosApi } from "../api";
import { familySessionKey, useFamilySession } from "../hooks/use-family-session";
import { RuntimeBanner } from "./RuntimeBanner";

export function AppShell() {
  const session = useFamilySession();
  const queryClient = useQueryClient();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const signOut = useMutation({
    mutationFn: () => mathosApi.signOut(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: familySessionKey });
      navigate("/login", { replace: true });
    },
  });

  return (
    <div className="app-frame">
      <RuntimeBanner />
      <header className="site-header">
        <NavLink to="/" className="brand-lockup" aria-label="返回学习台">
          <span className="brand-lockup__book" aria-hidden="true">
            甲
          </span>
          <span>
            <strong>MathOS</strong>
            <small>数学甲种本</small>
          </span>
        </NavLink>
        <nav className="site-nav" aria-label="主要导航">
          <NavLink to="/" end>
            <NotebookTabs aria-hidden="true" />
            <span>学习台</span>
          </NavLink>
          <Link
            to="/#course-map"
            className={
              location.pathname.startsWith("/lessons/")
                ? "active"
                : undefined
            }
          >
            <BookOpen aria-hidden="true" />
            <span>课程</span>
          </Link>
          <NavLink to="/parent/trial">
            <ShieldCheck aria-hidden="true" />
            <span>学习成果</span>
          </NavLink>
        </nav>
        <div className="profile-menu">
          <button
            type="button"
            className="profile-menu__trigger"
            aria-label={`打开${session.data?.childName ?? "孩子"}的家庭菜单`}
            aria-expanded={menuOpen}
            aria-haspopup="menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="profile-menu__avatar" aria-hidden="true">
              {session.data?.childName.slice(0, 1)}
            </span>
            <span className="profile-menu__names">
              <strong>{session.data?.childName}</strong>
              <small>{session.data?.parentName}的家庭</small>
            </span>
            <ChevronDown aria-hidden="true" />
          </button>
          {menuOpen && (
            <div className="profile-menu__panel" role="menu">
              <p>孩子不需要邮箱或手机号</p>
              <NavLink role="menuitem" to="/parent/trial">
                <ClipboardCheck aria-hidden="true" />
                孩子的试学进展
              </NavLink>
              <NavLink role="menuitem" to="/parent/data">
                <Database aria-hidden="true" />
                资料与记录
              </NavLink>
              <button
                type="button"
                role="menuitem"
                onClick={() => signOut.mutate()}
                disabled={signOut.isPending}
              >
                <LogOut aria-hidden="true" />
                退出家庭
              </button>
            </div>
          )}
        </div>
      </header>
      <Outlet />
    </div>
  );
}
